import TaskContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TaskContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import ScenarioLibrary from "../../../ngt/scenario/ScenarioLibrary";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import ChapterLibrary from "../../chapters/model/ChapterLibrary";
import PromiseUtil from "../../util/PromiseUtil";
import MissionBriefingEvent from "../model/MissionBriefingEvent";

export default class PushMissionBriefingCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ChapterLibrary} chapterLibrary 
     * @param {ScenarioLibrary} scenarioLibrary 
     */
    constructor(dispatcher, chapterLibrary, scenarioLibrary) {
        super(dispatcher);

        this._chapterLibrary = chapterLibrary;
        this._scenarioLibrary = scenarioLibrary;

        this._handleMissionBriefingFinishBound = this._handleMissionBriefingFinish.bind(this);
    }

    execute(evt) {
        /** @type {ScenarioPlayerEvent} */
        const data = evt.params.data;
        const { content, contentPlayer } = data;

        /** @type {TaskContent} */
        this._content = content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = contentPlayer;

        const scenario = this._scenarioLibrary.getCurrentScenario();

        this._briefingScreenSkin = this.openScreen(SkinKeyRegistry.MISSION_BRIEFING_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            allowClose: false,
            baseLpKey: `missionBriefings.${this._chapterLibrary.getCurrentChapter().id}.${scenario.id}`,
            backgroundImageId: scenario.missionBriefingBackgroundImageId,
        });

        this._dispatcher.addEventListener(MissionBriefingEvent.FINISH, this._handleMissionBriefingFinishBound);
    }

    async _handleMissionBriefingFinish(evt) {
        this._dispatcher.removeEventListener(MissionBriefingEvent.FINISH, this._handleMissionBriefingFinishBound);

        const transitionDuration = 450;
        this.closeScreen(this._briefingScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, transitionDuration, createjs.Ease.sineInOut),
        });

        await PromiseUtil.delay(transitionDuration);
        this._contentPlayer.contentCompleted(this._content);
    }
}